import { Checkbox as AntdCheckbox } from 'antd'
import classNames from 'classnames'
import type { ReactNode } from 'react'

import cn from './AtomCheckbox.module.scss'

type CheckboxProps = {
  checked: boolean
  onChange: (checked: boolean) => void
  children?: ReactNode
  isOrganisationSelected?: boolean
  disabled?: boolean
  className?: string
}

function AtomCheckbox({
  checked,
  onChange,
  children,
  isOrganisationSelected = false,
  disabled,
  className,
}: CheckboxProps) {
  return (
    <span
      className={classNames(
        cn.checkbox,
        isOrganisationSelected && cn.checkboxSelected,
        className
      )}
    >
      <AntdCheckbox
        checked={checked}
        disabled={disabled}
        onChange={(event) => onChange(event.target.checked)}
      >
        {children}
      </AntdCheckbox>
    </span>
  )
}

export default AtomCheckbox
